import { writable } from 'svelte-local-storage-store';
export const restaurantIdStore = writable('restaurantId', '');
